export const smartDocStaticParamType_Factor = 'factor';
//# sourceMappingURL=types.js.map